module.exports = __webpack_public_path__ + "img/chat_bg1.c19e91fb.png";